var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBack = function SvgIconBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M13.651 20.198a2.261 2.261 0 0 1-3.195 3.195L.66 13.598a2.26 2.26 0 0 1 0-3.196L10.456.607a2.26 2.26 0 0 1 3.195 3.195L5.453 12z"
  })));
};
export default SvgIconBack;